import { Component, ViewEncapsulation, Input } from '@angular/core';

import { FlightClass } from '@shared/base-search-bar/entities/flight-class';
import { AirValidationSector } from '@app/entities/air-validation.response';
import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { Price } from '@app/entities/price';
import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';

@Component({
  selector: 'app-itinerary-detail',
  templateUrl: 'itinerary-detail.component.html',
  styleUrls: ['./itinerary-detail.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})

export class ItineraryDetailComponent {

  @Input() airValidationSector: AirValidationSector[];
  @Input() flightClass: FlightClass;
  @Input() isMobile: boolean;
  @Input() provider: string;
  @Input() travelType: TravelBookingType;
  @Input() sectorSelected: string;
  @Input() price: Price;
  @Input() passengerArrangement: PassengerArrangement[];
  @Input() isLoadingFlightCabin: boolean;
  @Input() conversionRate: number;
  @Input() isInternational: boolean;
  @Input() productReference: number;

  public show: boolean = false;

  constructor() { }

  get isLoading(): boolean {
    return !!this.airValidationSector && this.airValidationSector.length === 0;
  }

  get isBus(): boolean {
    return this.travelType === TravelBookingType.BUSES;
  }
}
